import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { AppState, history } from 'src';

import { toggleModal } from '@common/components/common.actions';
import { IFrameHolder } from '@common/components/iframe-viewer/iframe-viewer.component';
import { ContractOrderType, ContractBalancesViewModel } from '@models/Contract';
import { HostedCheckoutTransactionCreateModel, PaymentMethods } from '@models/HostedCheckoutTransactionViewModel';
import { PaymentPurpose, PaymentTerms, PaymentType } from '@models/Payment';

import { HostedCheckoutComponentProperties, HostedCheckoutComponent } from './hosted-checkout.component';
import { buildCheckoutRequest } from '../../payment.actions';
import { cancelHostedTransaction } from '../../../transaction/transaction.actions';

export interface HostedCheckoutContainerProperties {
  readonly accountId?: number;
  readonly contractId?: number;
  readonly installmentsFee: number;
  readonly multiplePayments?: Array<ContractBalancesViewModel>;
  readonly orderType?: ContractOrderType;
  readonly paymentAmountBalance: number;
  readonly paymentAmountInitial?: number;
  readonly paymentDate?: Date;
  readonly paymentMethod: PaymentMethods;
  readonly paymentPurpose: PaymentPurpose;
  readonly paymentTerms: PaymentTerms;
  readonly paymentTypeBalance: PaymentType;
  readonly paymentTypeInitial: PaymentType;
  readonly remainingBalance: number;
  readonly remainingBalanceDueString: string;
  readonly totalPrice?: number;
  readonly getHiddenFormButton?: (button: HTMLButtonElement) => void;
}

// This is used to translate the state of the page to the props on the component
function mapStateToProps(
  state: AppState,
  ownProps: HostedCheckoutContainerProperties
): Partial<HostedCheckoutComponentProperties> {
  return {
    ...ownProps,
    installmentsFee: state.payment.installmentsFee,
    isPreAuthOnly: ownProps.paymentPurpose === PaymentPurpose.PreAuthorization,
    multiplePayments: ownProps.multiplePayments,
    payInInstallments: state.payment.paymentMethod === PaymentMethods.CCInstallments,
    usingSavedCard: !!state.payment.savedCreditCardInitial
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: HostedCheckoutContainerProperties
): Partial<HostedCheckoutComponentProperties> {
  return {
    buildCheckoutRequest(data: HostedCheckoutTransactionCreateModel, button: HTMLButtonElement) {
      const x = (e: Event) => {
        try {
          if (!e || !e.target) {
            return;
          }
          const elt: HTMLIFrameElement = e.target as HTMLIFrameElement;
          if (elt.contentWindow && elt.contentWindow.location) {
            const url = elt.contentWindow.location.pathname;
            if (!url.includes('transaction-landing')) {
              return;
            }
            dispatch(toggleModal());
            history.push(url);
          }
        } catch (e) {
          // do nothing
        }
      };
      return dispatch(
        buildCheckoutRequest({
          ...data,
          accountId: ownProps.accountId,
          contractId: ownProps.contractId
        })
        /* any here because I couldn't figure out the type */
      ).then((d: any) => {
        dispatch(
          toggleModal({
            bodyClasses: 'm-0 p-0 row',
            childProps: {
              src: '#',
              name: 'iframe_1',
              onFrameLoad: x
            },
            component: IFrameHolder,
            clickClose: () => {
              if (!d || !d.value || !d.value.x_reference_3) {
                return;
              }
              dispatch(cancelHostedTransaction(d.value.x_reference_3));
            },
            hideSave: true,
            title: 'Payment Portal'
          })
        );
        button.click();
      });
    }
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const HostedCheckout = connect(
  mapStateToProps,
  mapDispatchToProps
)(HostedCheckoutComponent);



// WEBPACK FOOTER //
// ./src/payment/_components/gateway/hosted-checkout-container.tsx